import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { IMG, RESERVE_URL } from "../mock";

const Bubbles = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    {[...Array(14)].map((_, i) => {
      const size = 6 + ((i * 7) % 26);
      return (
        <span
          key={i}
          className="bubble"
          style={{
            left: `${(i * 7.3) % 100}%`,
            width: size,
            height: size,
            animationDuration: `${9 + (i % 6) * 2}s`,
            animationDelay: `${(i % 7) * 1.3}s`,
          }}
        />
      );
    })}
  </div>
);

export default function Hero() {
  return (
    <section id="top" className="relative pt-36 pb-24 md:pt-44 md:pb-32">
      <div className="orb" style={{ width: 420, height: 420, background: "#06799b", top: -60, left: -80 }} />
      <div className="orb" style={{ width: 380, height: 380, background: "#0a4d68", top: 120, right: -60, animationDelay: "2s" }} />
      <Bubbles />

      <div className="relative mx-auto max-w-7xl px-5 grid lg:grid-cols-2 gap-12 items-center">
        <div className="reveal">
          <span className="inline-flex items-center gap-2 kicker">
            <Sparkles className="h-3.5 w-3.5" /> Plonge dans
          </span>
          <h1 className="font-display mt-4 text-4xl md:text-6xl xl:text-7xl font-semibold leading-[1.05] text-white">
            L'École des<br />
            <span className="gold-gradient-text">Maîtres Dauphins</span>
          </h1>
          <p className="mt-6 text-lg md:text-xl text-white/75 max-w-xl leading-relaxed">
            Le futur de l'accompagnement :
            <span className="text-aqua"> multi-conscience</span>,
            <span className="text-aqua"> cohérence</span>,
            <span className="text-aqua"> champ</span>.
            <br className="hidden md:block" />
            Une pratique high level — présentiel &amp; distance.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-4">
            <a href={RESERVE_URL} target="_blank" rel="noreferrer"
               className="btn-gold px-7 py-4 inline-flex items-center gap-2">
              Je réserve ma place
              <ArrowRight className="h-4 w-4" />
            </a>
            <a href="#shift" className="btn-ghost px-7 py-4 inline-flex items-center">
              Découvrir le shift
            </a>
          </div>

          <div className="mt-10 flex items-center gap-8">
            {[
              { n: "14", l: "fréquences" },
              { n: "25 ans", l: "d'expérience" },
              { n: "∞", l: "accès à vie" },
            ].map((s) => (
              <div key={s.l}>
                <div className="font-display text-2xl md:text-3xl text-gold">{s.n}</div>
                <div className="text-xs uppercase tracking-widest text-white/50">{s.l}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative reveal">
          <div className="relative mx-auto max-w-[520px]">
            <div className="absolute -inset-6 rounded-full bg-[#6fe3e0]/10 blur-3xl" />
            <div className="relative floaty rounded-[2rem] overflow-hidden border border-white/10 shadow-2xl">
              <img
                src={IMG.heroDolphin}
                alt="Dauphins lumineux"
                className="w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#041824]/60 via-transparent to-transparent" />
            </div>
            <div className="absolute -bottom-6 -left-4 md:-left-8 glass-strong rounded-2xl px-5 py-4 floaty-slow">
              <div className="text-xs uppercase tracking-widest text-aqua">Raisonnement → Résonance</div>
              <div className="font-display text-lg text-white mt-0.5">La pratique du futur</div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-5 mt-20">
        <div className="shimmer-line" />
      </div>
    </section>
  );
}
